<template>
  <div class="pre-example-wrapper">
    <h3 class="title">
      <img :src="require('@/assets/img/icon_info_circle.png')" alt="" />
      <p>{{ title }}</p>
    </h3>
    <div class="content">
      <div class="arrow"></div>
      <img :src="url" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'preExample',
  props: ['title', 'url'],
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.pre-example-wrapper {
  .title {
    display: flex;
    align-items: center;
    color: #707070;
    font-size: 14px;
    line-height: 1.4;
    img {
      margin-right: 8px;
      height: 14px;
      width: 14px;
    }
  }
  .content {
    position: relative;
    width: 224px;
    height: 311px;
    border-radius: 2px;
    border: 1px solid #f2f2f2;
    background-color: #f2f2f2;
    padding: 14px;
    img {
      height: 100%;
      width: 100%;
    }
    .arrow {
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      top: -15px;
      left: 28px;
      border-color: transparent;
      border-style: solid;
      &::after {
        border-top-width: 0;
        content: ' ';
        border-width: 6px;
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-bottom-color: #f2f2f2;
        border-style: solid;
      }
    }
  }
}
</style>
